import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import { memo, useContext, useEffect, useState } from 'react';
import ReviewContent from 'pages/manage-topics/manage-contents/Tabs/ReviewContent';
import { UserContext } from 'context/UserContext';
import { ROLES } from 'utilities/constants';
import UserSelect from 'components/molecules/UserSelect';

function AssignTo({ open, closeModal, data = {}, fns = {} }) {
  const [status, setStatus] = useState('inactive');
  const [contentOwner, setContentOwner] = useState();
  const [contentTutor, setContentTutor] = useState();

  const { userInfo = {} } = useContext(UserContext);
  const { key } = userInfo?.data ?? {};

  const isSE = key === ROLES.SUBJECT_EXPERT;
  const isTeacher = key === ROLES.TUTOR;

  let __teacherVisitedAllQuestions = true;
  let __teacherRatedAllQuestions = true;
  let __needToRateAndReview = false;

  const { handleSave } = fns || {};
  const { apiInfo = {}, reviewStatus, reviewOptions, changeableStatus } = data || {};
  const { visitedQuestions, ratedQuestions } = data || {};
  const { quizCategory } = apiInfo || {};

  useEffect(() => {
    if (reviewStatus) setStatus(reviewStatus);
  }, [reviewStatus]);

  useEffect(() => {
    if (data?.contentOwner) setContentOwner(data?.contentOwner);
    if (data?.assignedTutorForReview) setContentTutor(data?.assignedTutorForReview);
  }, [data]);

  const __isUnderReview = isSE && [('qc_review', 'teacher_review')].includes(reviewStatus);

  if (isTeacher && !['mock_test', 'previous_year'].includes(quizCategory)) {
    __teacherVisitedAllQuestions =
      visitedQuestions?.total !== 0 && visitedQuestions?.total <= visitedQuestions?.visited;
  }

  if (isTeacher && !['mock_test', 'previous_year'].includes(quizCategory)) {
    __teacherRatedAllQuestions =
      ratedQuestions?.total !== 0 && ratedQuestions?.total <= ratedQuestions?.rated;
  }

  __needToRateAndReview = isTeacher && !__teacherVisitedAllQuestions && !__teacherRatedAllQuestions;

  return (
    <AppModal open={open} closeModal={closeModal} size="md">
      <AppModalHeader>Assign</AppModalHeader>
      <AppModalBody classNames="p-4">
        <div className="row">
          <div className="col-6 mb-4">
            <ReviewContent
              selectProps={{
                disabled: !__teacherVisitedAllQuestions || !__teacherRatedAllQuestions,
              }}
              area={{
                reviewOptions: reviewOptions.map((r) => {
                  if (
                    changeableStatus?.length > 0 &&
                    reviewStatus &&
                    !changeableStatus?.includes?.(r.value)
                  )
                    r.isDisabled = true;
                  return r;
                }),
              }}
              value={status}
              onChange={(value) => setStatus(value)}
            />
            {__needToRateAndReview && (
              <>
                <small className="text-danger">
                  You must review and give rating to all questions before you can make the status
                  change.
                </small>
              </>
            )}
            {!__needToRateAndReview && !__teacherVisitedAllQuestions && (
              <>
                <small className="text-danger">
                  Please review all the questions and then come back to change the assignee status.
                </small>
              </>
            )}
            {!__needToRateAndReview && !__teacherRatedAllQuestions && (
              <>
                <small className="text-danger">
                  Please give a rating to all questions and then come back to change the assignee
                  status.
                </small>
              </>
            )}
          </div>

          <div className="col-6  mb-4">
            <label>Content owned by</label>
            <UserSelect
              dependencies={{ query: { roles: [ROLES.SUBJECT_EXPERT] } }}
              handleChange={setContentOwner}
              values={contentOwner}
              isMulti={false}
            />
          </div>
        </div>
        <div className="row mt-4">
          {((isSE && status === 'teacher_review') || !isSE) && (
            <div className="col-6  mb-4">
              <label>Please pick a teacher</label>
              <UserSelect
                dependencies={{ query: { roles: [ROLES.TUTOR] } }}
                handleChange={setContentTutor}
                values={contentTutor}
                isMulti={false}
              />
            </div>
          )}
        </div>
        <div className="d-flex flex-row mt-4 justify-content-center">
          {!__isUnderReview && __teacherVisitedAllQuestions && (
            <AppButton
              variantClass="btn-primary mx-3"
              style={{ minWidth: '1.5rem' }}
              onClick={() => {
                if (reviewStatus === status) return;

                if (status === 'teacher_review' && !contentTutor) {
                  window.alert('Please pick a teacher');
                  return;
                }

                handleSave({
                  ...apiInfo,
                  reviewStatus: status,
                  contentOwner: contentOwner?._id,
                  assignedTutorForReview: contentTutor?._id,
                });
              }}
            >
              Save
            </AppButton>
          )}
          {(__isUnderReview || !__teacherVisitedAllQuestions) && (
            <AppButton
              variantClass="btn-primary mx-3"
              style={{ minWidth: '1.5rem' }}
              onClick={closeModal}
            >
              Close
            </AppButton>
          )}
        </div>
      </AppModalBody>
    </AppModal>
  );
}

export default memo(AssignTo);
